import { useState, useRef, useCallback } from "react";

/**
 * Hook genérico para obtener el HTML generado por un componente React.
 *
 * Ejemplo de uso:
 * const { fetchHtml, HtmlRenderer } = useHtmlRIFetcher(ResumenIngresoPrint);
 *
 * const html = await fetchHtml({ idDatosGeneralesRI: 123 });
 */
export const useHtmlRIFetcher = (Component) => {
  const [props, setProps] = useState(null);
  const resolverRef = useRef(null);

  // Promesa que resuelve el HTML una vez que el componente avisa que terminó
  const fetchHtml = useCallback((newProps) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setProps(newProps);
    });
  }, []);

  // Callback para cuando el componente hijo completa el render del HTML
  const handleReady = useCallback((html) => {
    if (resolverRef.current) {
      resolverRef.current(html);
      resolverRef.current = null;
      setProps(null); // limpia el render oculto
    }
  }, []);

  // Render oculto del componente que genera el HTML
  const HtmlRenderer = (
    <div style={{ display: "none" }}>
      {props && <Component {...props} onReady={handleReady} />}
    </div>
  );

  return { fetchHtml, HtmlRenderer };
};
